export enum ItemType {
  Commercial = 'COMM',
  concrete = 'TECH',
  Pump = 'PUMP',
  ValueAdded = 'VA',
  AdditionalService = 'ADDS',
  Environment = 'ENV',
  Pipe = 'PIPE',
  ExtraProduct = 'EXTP',
  RawMaterial = 'RAW',
}

export enum VehicleType {
  ConcretePumpMixerTruck = '992',
  ConcretePump = '993',
  ConcreteMixerTruck = '994',
  MixerConveyorTruck = '995',
  ConcreteStationaryPump = '996',
  RigidTipper = '923',
  SemiTrailerDumpTruck = '925',
  TrailerTruck = '931',
  DumpTruck = '934',
  OpenHopperTruck = '936',
  Tractors = '976',
  ConcreteMobileDose = '991',
}

export enum ServiceIndicatorType {
  additives = 'ADI',
  additions = 'ADC',
  fibers = 'FIB',
  additionalServices = 'ADDS',
  extraProduct = 'EXTP',
}

export enum LoadType {
  L001 = 'L001',
}
